<template>
  <div class="start flex flex-wrap">

    <vue-headful
      :title=title
      :description=description
      image="https://foodi.de/static/og_image.jpg"
      lang="de"
      ogLocale="de_DE"
      url="https://foodi.de/"
    />

    <div class="w-full">
      <div class="heading-styles flex items-center justify-between flex-wrap">
        <h1 class="border-0 m-0 p-0 flex-shrink-0 flex-grow">{{ matchingHostCount }} Anbieter für {{ location.item_ort_einfach }}</h1>
        <br />
        <heinz-host-filter :foodtypes="foodtypes" />
        <heinz-host-search v-model="searchQuery" />
      </div>

      <div v-if="realHostsCount === 0">
        <p class="pb-8">
          Für den gewählten Ort können wir Dir leider noch kein Restaurant oder Lieferservice anbieten 🤷‍♂️ Wir arbeiten dran!<br />
          Gerne kannst du uns deinem Lieblingsanbieter vorschlagen. &#128293; Oder du bist selbst Anbieter? <router-link tag="a" :to="{ name: 'Registration' }">Hier kannst du dich registrieren!</router-link>
        </p>
        <recommend class="mt-4" mode="recommend"></recommend>
      </div>

      <div v-if="!Object.values(filteredRealHosts).length && searchQuery">
        <p class="pb-8">
          Wir konnte leider keine passenden Restaurants oder Lieferdienste zu deiner Suche finden.
        </p>
      </div>

      <div v-for="host in filteredRealHosts" :key="host.id"
        class="host bg-white mx-auto shadow-lg rounded-lg mb-6 overflow-hidden relative"
        :class="{
          'open': host.config_open.now,
          'inactive': host.item_active == 'N',
          'reactivate': host.item_auto_reactivate !== null,
          'autoinactive': host.item_auto_inactive === 'Y',
          'inactive vacation': host.item_away_id != null,
          'isnew': host.item_new
        }"
        @click="autoReactivateInfo(host)"
      >
        <div class="top">
          TOP
        </div>
        <div v-if="host.item_coupon_kickback > 0" @click="toggleKickbackInfo(host)" class="kickback md:text-left cursor-pointer" style="position: absolute; left:-2px; writing-mode: vertical-rl; height:100%;" tabindex="-1">
          <div class="bg-green-heinz text-center text-black text-sm py-2 rounded-l-lg" style="top:0; height: 100%;"><nobr>🎉 {{ host.item_coupon_kickback }}% Treuebonus</nobr></div>
        </div>
        <div v-if="host.isLasthost" class="text-center md:text-left md:pl-6">
          <span class="bg-green-heinz text-black text-sm px-2 py-1 rounded">Hier hast du zuletzt bestellt ☝️</span>
        </div>
        <div class="sm:flex sm:items-center px-6 py-4">
          <a v-if="host.item_logo != ''" v-on:click="selectHost(host)" class="no-underline" tabindex="-1">
            <img class="hostlogo block rounded-full mx-auto mb-4 sm:mb-0 sm:mr-4 sm:ml-0" :src="host.item_logo" :alt="'Logo ' + host.item_name">
          </a>
          <div class="sm:flex-grow w-full md:w-1/2 pl-2">
            <div class="mb-4">
              <div class="text-xl leading-tight font-bold">
                <h2 class="no-underline text-xl border-none mb-0 pb-0"><a v-on:click="selectHost(host)" class="no-underline hover:underline text-black" role="button" tabindex="-1">{{ host.item_name }}</a></h2>

                <!-- <a v-on:click="selectHost(host)" class="no-underline hover:underline text-black" role="button" tabindex="-1">{{ host.item_name }}</a> -->
                <div v-if="host.item_auto_reactivate !== null">ab {{ host.item_auto_reactivate }} Uhr wieder verfügbar!</div>
                <div v-if="host.item_active_delivery === 'N'" class="font-bold text-orange-darker">⚠️ kurzzeitig keine Lieferung möglich</div>
                <div v-if="host.item_active_pickup === 'N'" class="font-bold text-orange-darker">⚠️ kurzzeitig keine Abholung möglich</div>
              </div>
              <p v-if="host.item_foodtype !== ''" class="text-sm leading-tight font-bold text-green-darker">{{ host.item_foodtype }}</p>
              <p class="text-sm leading-tight text-grey-darker">
                aus {{ host.item_ort }}
                <template v-if="host.item_distance > 0"> - {{ (Math.round(host.item_distance / 100) / 10) }} km bzw. {{ Math.round(host.item_duration / 60) }} Minuten Fahrzeit</template>
              </p>
              <p v-if="host.item_has_special === 'Y'" class="pt-2 text-sm leading-tight font-bold text-green-darker">🔥 Aktuelles Sonderangebot</p>
              <div v-if="!host.config_open.now" class="font-bold pt-2 text-orange-darker">
                ⏱ Momentan geschlossen, Vorbestellung möglich
              </div>
            </div>
            <div v-if="host.item_active == 'Y' && host.item_away_id == null">
              <button v-on:click="selectHost(host)" class="text-xs font-semibold rounded-full px-4 py-1 leading-normal bg-green-heinz border border-green-heinz text-black hover:bg-white hover:text-green-heinz-darkest hover:border-green-heinz-darkest" :aria-label="'Speisekarte ' + host.item_name ">
                Speisekarte
              </button>
            </div>
          </div>
          <div class="sm:flex-grow self-start w-full my-4 md:my-0 md:w-1/4 text-sm leading-tight">
            Öffnungszeiten:<br />
            <ul class="list-reset text-grey-darker">
              <li v-for="time in host.config_open.times" :key="time.open + time.close">
                {{ time.open }} bis {{ time.close }}
                <img v-if="time.zeroday" src="/static/icons/accept.png" alt="Spezielle Öffnungszeit" title="Spezielle Öffnungszeit des Anbieters für den heutigen Tag" />
                <span v-if="time.type === 'pickup'" class="text-orange-darker">keine Lieferung</span>
                <span v-if="time.type === 'delivery'" class="text-orange-darker">keine Abholung</span>
              </li>
            </ul>
            <span v-if="!host.config_open.times" class="font-bold text-orange-darker">heute Ruhetag</span>
          </div>
          <div class="sm:flex-grow self-start w-full md:w-1/4 text-sm leading-tight">
            <div v-if="host.item_new !== null" class="text-green-heinz-darkest text-xl">NEU!</div>
            <div v-if="host.item_review === 'allow' && host.item_new === null">
              Bewertungen:<br />
              <rating v-if="host.item_review_count > 5" :value="host.item_avg"></rating>
              <router-link tag="a" :to="{ name: 'Bewertungen', params: { hostUrl: host.item_url } }" class="text-grey-darker hover:underline">Bewertungen lesen ({{ host.item_review_count }})</router-link>
            </div>
            <div v-if="host.item_review !== 'allow'">Bewertungen deaktiviert</div>
          </div>
        </div>
        <div class="px-6 py-4 text-sm">
          <div class="mb-1">
            <div class="hostfeature available">Abholung</div>
            <div class="hostfeature" :class="{ 'available': host.item_homedelivery == 'Y' }">Lieferung</div>
            <div class="hostfeature" :class="{ 'available': host.item_allow_bookatable == 'Y' }">Tischreservierung</div>
            <div class="hostfeature" :class="{ 'available': host.item_webpayment == 'Y' }">Onlinezahlung</div>
            <div class="hostfeature" :class="{ 'available': host.item_payment_ec == 'Y' }">EC Zahlung</div>
            <div class="hostfeature" :class="{ 'available': host.item_payment_cash == 'Y' }">Barzahlung</div>
          </div>
          <template v-if="host.item_homedelivery == 'Y'">
            <p>
              <span><template v-if="host.item_mbw == 0">Kein Mindestbestellwert</template><template v-else>Lieferung ab {{ host.item_mbw | pricetag }}</template> &bull;</span>
              <span v-if="host.item_shipping == 0">Keine Lieferkosten</span>
              <span v-if="host.item_shipping != 0">{{ host.item_shipping | pricetag }} Lieferkosten</span>
              <span v-if="host.item_shipping != 0 && host.item_free != 0"> &bull; Kostenlose Lieferung ab {{ host.item_free | pricetag }}</span>
            </p>
            <p>
              <span v-if="host.item_delivery_minutes > 0" class="text-grey-darker">
                Ø Lieferzeit letzte 10 Bestellungen:
                <span v-if="host.item_delivery_minutes <= 60">{{ host.item_delivery_minutes }}</span>
                <span v-else>60+</span>
                Min.
              </span>
            </p>
          </template>
        </div>
      </div>

      <div v-if="realHostsCount > 0 && realHostsCount <= 8">
        <p class="pb-8 text-center mt-8">
          Hier ist momentan leider noch recht wenig los. Wir arbeiten dran!<br />
          Gerne kannst du uns <router-link class="text-black" tag="a" :to="{ name: 'Recommend' }">ein Restaurant empfehlen</router-link>. &#128293; Oder du bist selbst Anbieter? <router-link class="text-black" tag="a" :to="{ name: 'Registration' }">Hier kannst du dich registrieren!</router-link>
        </p>
      </div>
    </div>

    <dialog adaptive class="z-50 kickback-info-dialog" name="kickbackinfo" id="kickback-info-dialog" height="auto">
      <div class="dialog__content">
        <h3 class="headline-extras">{{ kickbackSelectedHost.item_coupon_kickback }}% Treuebonus</h3>
        <p class="block text-grey-darker mb-1 md:mb-0 pr-4">
          {{ kickbackSelectedHost.item_name }} nimmt an unserm Treuebonus-Programm teil. Das bedeutet für dich, dass du mit deiner Bestellbestätigung einen Rabattgutschein i.H.v. {{ kickbackSelectedHost.item_coupon_kickback }}% des Warenwertes für deine nächste Bestellung bei diesem Restaurant erhältst 🎉<br />
        </p>
        <button @click="closeDialog('kickback-info-dialog')" class="shadow bg-green-heinz hover:bg-green-heinz-light text-black font-bold mt-4 py-2 px-4 rounded cursor-pointer" type="button">
          Info schließen
        </button>
      </div>
    </dialog>
  </div>
</template>

<script>
import endpoints from '../../endpoints'
import { mapGetters, mapMutations } from 'vuex'
import _ from 'lodash'
import axios from 'axios'
import Rating from '../../components/Rating.vue'
import Recommend from '../recommend/index.vue'
import HostSearch from '../../components/HostSearch.vue'
import HostFilter from '../../components/HostFilter.vue'
import { openDialog, closeDialog } from '../../utils/dialog'
import { markNoindex, markIndex } from '../../utils/seo'

export default {
  name: 'Anbieter',

  data () {
    return {
      searchQuery: '',
      geoUrl: this.$route.params.geoUrl,
      hosts: {},
      lasthost: {},
      location: {},
      foodtypes: {},
      realHostsCount: null,
      title: 'Anbieter auswählen - foodi.de',
      description: 'Essen online bestellen - keine Verständnis­probleme, keine Miss­verständ­nisse. Online­zahlung per PayPal, per Sofortüberweisung oder Barzahlung möglich.',
      kickbackSelectedHost: {}
    }
  },

  computed: {
    ...mapGetters([
      'getScrollLocation',
      'locationFilter',
      'isLoggedIn',
      'user'
    ]),

    filteredRealHosts () {
      let realHosts = _.sortBy(this.hosts.real, (item) => {
        return item.item_sort
      })

      if (!realHosts || !(Object.values(realHosts).length)) return {}

      if (this.lasthost) {
        _.remove(realHosts, {
          id: this.lasthost.id
        })

        realHosts.unshift(this.lasthost)
      }

      let filteredHosts = realHosts
      if (this.searchQuery) {
        filteredHosts = {}
        let searchQueryWithWildcards = ''
        for (let i = 0; i < this.searchQuery.length; i++) {
          searchQueryWithWildcards += this.searchQuery.charAt(i) + '.?'
        }

        const searchRegexp = new RegExp(searchQueryWithWildcards, 'i')
        for (let hostId in realHosts) {
          if (realHosts[hostId].item_name.match(searchRegexp)) {
            filteredHosts[hostId] = realHosts[hostId]
          }
        }
      }

      if (!this.locationFilter.showPickups) {
        filteredHosts = Object.values(filteredHosts).filter((item) => {
          return item.item_homedelivery === 'Y'
        })
      }

      if (!this.locationFilter.showClosed) {
        filteredHosts = Object.values(filteredHosts).filter((item) => {
          return item.config_open.now && item.item_active === 'Y' && item.item_away_id == null
        })
      }

      if (this.locationFilter.foodType) {
        filteredHosts = Object.values(filteredHosts).filter((item) => {
          return Object.values(item.item_foodtype_array).find(foodtype => foodtype === this.locationFilter.foodType)
        })
      }

      return filteredHosts
    },

    matchingHostCount () {
      return this.filteredRealHosts ? Object.keys(this.filteredRealHosts).length : 0
    }
  },
  watch: {
    filteredRealHosts (val) {
      const total = this.realHostsCount
      if (val && Object.values(val).length) {
        markIndex()
      } else if (!total || total === 0) {
        markNoindex()
      }
    }
  },

  components: {
    'rating': Rating,
    'recommend': Recommend,
    'heinz-host-search': HostSearch,
    'heinz-host-filter': HostFilter
  },

  created () {
    axios.post(endpoints.hosts, {
      'geourl': this.geoUrl
    })
      .then(response => {
        this.hosts = response.data.hosts
        this.lasthost = response.data.lasthost
        this.location = response.data.location
        this.foodtypes = response.data.foodtypes
        this.realHostsCount = _.size(response.data.hosts.real)
        this.title = 'Restaurants in ' + response.data.location.item_ort_einfach + ' | ' + this.site.domain
        this.description = 'Essen in ' + response.data.location.item_ort_einfach + ' online bestellen - keine Verständnis­probleme, keine Miss­verständ­nisse. Online­zahlung per PayPal, per Sofortüberweisung oder Barzahlung möglich.'

        this.autoScroll()
        this.$nextTick(() => {
          this.injectJsonLd()
          if (this.filteredRealHosts && Object.values(this.filteredRealHosts).length) {
            markIndex()
          } else {
            markNoindex()
          }
        })
      })
      .catch(e => {
        console.log(e)
      })
  },

  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },

  methods: {
    ...mapMutations([
      'setScrollLocation'
    ]),

    closeDialog,

    selectHost (host) {
      window.hostId = host.id

      axios.post(endpoints.sethost + host.id, {})
        .then(response => {
          this.$router.push({ name: 'Shop', params: { hostUrl: host.item_url } })
        })
        .catch(e => {
          this.errors.push('Der gewählte Anbieter konnte nicht ausgewählt werden 😭')
        })
    },

    autoReactivateInfo (host) {
      if (host.item_active === 'N') {
        if (host.item_auto_reactivate !== null) {
          if (confirm('Hier kannst du erst ab ' + host.item_auto_reactivate + ' Uhr wieder bestellen. Möchtest du dir dennoch die Speisekarte anschauen?')) {
            this.selectHost(host)
          }
        } else {
          alert('Der gewählte Anbieter ist derzeit leider nicht verfügbar.')

          if (this.isLoggedIn && this.user.id === 1) {
            this.selectHost(host)
          }
        }
      }
    },

    autoScroll () {
      this.$nextTick(() => {
        window.scrollTo(0, this.getScrollLocation)
        window.addEventListener('scroll', this.handleScroll)
      })
    },

    handleScroll () {
      this.setScrollLocation(window.scrollY)
    },

    toggleKickbackInfo (host) {
      this.kickbackSelectedHost = host
      openDialog('kickback-info-dialog')
    },
  injectJsonLd () {
      const id = 'jsonld-anbieter-itemlist'
      const old = document.getElementById(id)
      if (old) old.parentNode.removeChild(old)
      if (!this.filteredRealHosts || !Object.values(this.filteredRealHosts).length) return
      const hostsArray = Object.values(this.filteredRealHosts)
      const script = document.createElement('script')
      script.id = id
      script.type = 'application/ld+json'
      script.textContent = JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        'itemListElement': hostsArray.slice(0, 50).map((h, idx) => {
          let aggregate = null
          if (h.item_review_count > 5 && h.item_avg != null) {
            const rv = parseFloat(String(h.item_avg).replace(',', '.'))
            const rc = parseInt(h.item_review_count, 10)
            if (!isNaN(rv) && rv >= 1 && rv <= 5 && rc > 0) {
              aggregate = {
                '@type': 'AggregateRating',
                'ratingValue': rv.toFixed(1),
                'ratingCount': rc,
                'reviewCount': rc,
                'bestRating': 5,
                'worstRating': 1
              }
            }
          }
          return {
            '@type': 'ListItem',
            'position': idx + 1,
            'item': {
              '@type': 'Restaurant',
              'name': h.item_name,
              'url': window.location.origin + '/shop/' + h.item_url,
              ...(aggregate ? { 'aggregateRating': aggregate } : {})
            }
          }
        })
      })
      document.head.appendChild(script)
      // Detaillierte Top 3
      const detailedId = 'jsonld-anbieter-local'
      const old2 = document.getElementById(detailedId)
      if (old2) old2.parentNode.removeChild(old2)
      const top3 = hostsArray.slice(0, 3).map(h => {
        let aggregate = null
        if (h.item_review_count > 5 && h.item_avg != null) {
          const rv = parseFloat(String(h.item_avg).replace(',', '.'))
          const rc = parseInt(h.item_review_count, 10)
          if (!isNaN(rv) && rv >= 1 && rv <= 5 && rc > 0) {
            aggregate = {
              '@type': 'AggregateRating',
              'ratingValue': rv.toFixed(1),
              'ratingCount': rc,
              'reviewCount': rc,
              'bestRating': 5,
              'worstRating': 1
            }
          }
        }
        return {
          '@type': 'Restaurant',
          'name': h.item_name,
          'url': window.location.origin + '/shop/' + h.item_url,
          ...(h.item_foodtype ? { 'servesCuisine': h.item_foodtype.split(',').map(s => s.trim()).slice(0, 5) } : {}),
          ...(aggregate ? { 'aggregateRating': aggregate } : {})
        }
      })
      const script2 = document.createElement('script')
      script2.id = detailedId
      script2.type = 'application/ld+json'
      script2.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': top3 })
      document.head.appendChild(script2)
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    cursor: pointer;
  }

  .hostlogo {
    width: 100px;
    height: auto;
  }

  .host {
    @apply border-2;
    @apply border-orange-dark;
  }

  .host.open:not(.inactive) {
    @apply border-green-heinz;
  }

  .host.inactive {
    position: relative;

    &:after {
      content: 'Derzeit leider nicht verfügbar 😭';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      text-align: center;
      padding: 0 1.5rem;
      font-size: 24px;
      color: #666;
      background-color: rgba(255, 255, 255, .85);
      cursor: default;
    }

    &.isnew {
      &:after {
        content: 'In Kürze für dich verfügbar 🔥';
      }
    }

    &.reactivate {
      &:after {
        content: 'Ausgelastet und in Kürze wieder verfügbar ℹ️';
      }
    }

    &.autoinactive {
      &:after {
        content: 'Aktuell leider nicht erreichbar 🤷‍♂️';
      }
    }

    &.vacation {
      &:after {
        content: 'Betriebsferien ☀️';
      }
    }
  }

  .hostfeature {
    @apply inline-block;
    @apply rounded-full;
    @apply px-2;
    @apply py-1;
    @apply text-xs;
    @apply font-bold;
    @apply mr-3;
    @apply mb-3;
    @apply max-w-xs;
    @apply border;
    @apply border-grey-darker;
    @apply text-grey-darker;

    &:after {
      content: ' nicht möglich';
    }

    &.available {
      @apply bg-green-heinz;
      @apply border-black;
      @apply text-black;

      &:after {
        content: ' möglich';
      }
    }
  }

  .host > .top {
    display: none;
  }

  .host.special > .top {
    display: block;
  }

  .special {
    border: 2px solid;
    @apply border-green-heinz;
    @apply mb-12;
    position: relative;

    &:after {
      content: "WERBUNG";
      color: grey;
      font-size: 10px;
      margin-left: 10px;
    }

  }

  .top {
    @apply bg-green-heinz;
    @apply text-white;
    position: absolute;
    top: 0;
    right: 0;
    font-size: 12px;

    padding: 10px;

  }

  .heading-styles{
    @apply border-b-3;
    @apply border-green-heinz;
    margin-bottom: 20px;
    padding-bottom: 10px;
  }

</style>



// WEBPACK FOOTER //
// src/views/locations/select.vue